export const experiences = [
  {
    id: 1,
    title: 'Heritage & Culture',
    titleEs: 'Patrimonio y Cultura',
    description: 'Ancient monuments whisper stories of dynasties past',
    descriptionEs: 'Monumentos antiguos susurran historias de dinastías pasadas',
    image: 'https://images.unsplash.com/photo-1524492412937-b28074a5d7da?w=1200&q=85',
    icon: 'landmark'
  },
  {
    id: 2,
    title: 'Yoga & Wellness',
    titleEs: 'Yoga y Bienestar',
    description: 'Find peace through ancient practices by sacred rivers',
    descriptionEs: 'Encuentra paz a través de prácticas antiguas junto a ríos sagrados',
    image: 'https://images.unsplash.com/photo-1758797315487-b3b225dff7d8?crop=entropy&cs=srgb&fm=jpg&q=85',
    icon: 'heart'
  },
  {
    id: 3,
    title: 'Nature & Wildlife',
    titleEs: 'Naturaleza y Vida Silvestre',
    description: 'Where tigers roam and the earth breathes life',
    descriptionEs: 'Donde los tigres deambulan y la tierra respira vida',
    image: 'https://images.unsplash.com/photo-1676634694424-2938c2d7da43?crop=entropy&cs=srgb&fm=jpg&q=85',
    icon: 'trees'
  },
  {
    id: 4,
    title: 'Artisans & Communities',
    titleEs: 'Artesanos y Comunidades',
    description: 'Meet the hands that weave India\'s cultural fabric',
    descriptionEs: 'Conoce las manos que tejen el tejido cultural de India',
    image: 'https://images.unsplash.com/photo-1640292343595-889db1c8262e?crop=entropy&cs=srgb&fm=jpg&q=85',
    icon: 'palette'
  },
  {
    id: 5,
    title: 'VR India Experience',
    titleEs: 'Experiencia VR India',
    description: 'Travel from anywhere—immersive virtual journeys',
    descriptionEs: 'Viaja desde cualquier lugar: viajes virtuales inmersivos',
    image: 'https://images.unsplash.com/photo-1678788166239-b28733f56956?crop=entropy&cs=srgb&fm=jpg&q=85',
    icon: 'compass'
  }
];

export const destinations = [
  {
    id: 1,
    slug: 'delhi',
    name: 'Delhi',
    description: 'Where centuries collide in vibrant harmony',
    descriptionEs: 'Donde los siglos chocan en vibrante armonía',
    image: 'https://images.unsplash.com/photo-1713729991304-d0b6c328560e?crop=entropy&cs=srgb&fm=jpg&q=85',
    heroImage: 'https://images.unsplash.com/photo-1587474260584-136574528ed5?crop=entropy&cs=srgb&fm=jpg&q=85',
    overview: 'Delhi, India\'s capital territory, is a massive metropolitan area in the country\'s north. Ancient and modern coexist here - from the 17th-century Red Fort and Jama Masjid mosque to towering skyscrapers and bustling markets. Experience the perfect blend of Mughal architecture, colonial heritage, and contemporary culture.',
    tagline: 'A timeless tapestry of history and modernity',
    bestTime: 'October to March (pleasant weather, avoiding extreme heat)',
    attractions: [
      'Red Fort - UNESCO World Heritage Site and symbol of India\'s independence',
      'Qutub Minar - World\'s tallest brick minaret dating back to 1193',
      'India Gate - War memorial honoring 70,000 Indian soldiers',
      'Humayun\'s Tomb - Precursor to the Taj Mahal architecture',
      'Lotus Temple - Architectural marvel and Bahá\'í House of Worship',
      'Chandni Chowk - 17th-century market with narrow lanes and street food',
      'Akshardham Temple - Modern architectural wonder',
      'Raj Ghat - Memorial to Mahatma Gandhi'
    ],
    facts: [
      'Delhi has been continuously inhabited for over 2,500 years',
      'Home to 3 UNESCO World Heritage Sites',
      'The city has been rebuilt and destroyed 11 times throughout history',
      'Chandni Chowk is one of Asia\'s largest wholesale markets',
      'Delhi has more than 1,200 heritage buildings',
      'The Delhi Metro is the world\'s 10th largest metro system'
    ],
    thingsToDo: [
      'Explore Old Delhi on a rickshaw ride through narrow lanes',
      'Take a food tour sampling street food like parathas, chaat, and kebabs',
      'Visit the spice market in Khari Baoli, Asia\'s largest',
      'Watch the Sound and Light Show at Red Fort',
      'Shop for traditional textiles at Dilli Haat',
      'Experience the changing of guard ceremony at Rashtrapati Bhavan'
    ],
    howToReach: 'Indira Gandhi International Airport (DEL) connects Delhi to major cities worldwide. The city is well-connected by rail and road to all parts of India.',
    gallery: [
      'https://images.unsplash.com/photo-1587474260584-136574528ed5?crop=entropy&cs=srgb&fm=jpg&q=85',
      'https://images.unsplash.com/photo-1713729991304-d0b6c328560e?crop=entropy&cs=srgb&fm=jpg&q=85',
      'https://images.unsplash.com/photo-1744979197022-f9f70e8a9402?crop=entropy&cs=srgb&fm=jpg&q=85',
      'https://images.unsplash.com/photo-1524492412937-b28074a5d7da?w=1200&q=85'
    ],
    metaTitle: 'Delhi Travel Guide - Explore India\'s Historic Capital | POMTrips',
    metaDescription: 'Discover Delhi\'s rich heritage, from Red Fort to Qutub Minar. Explore ancient monuments, vibrant markets, and experience 2,500 years of history.'
  },
  {
    id: 2,
    slug: 'agra',
    name: 'Agra',
    description: 'Home to eternal love, carved in white marble',
    descriptionEs: 'Hogar del amor eterno, tallado en mármol blanco',
    image: 'https://images.unsplash.com/photo-1548013146-72479768bada?crop=entropy&cs=srgb&fm=jpg&q=85',
    heroImage: 'https://images.unsplash.com/photo-1524492412937-b28074a5d7da?w=1200&q=85',
    overview: 'Agra, the city of the Taj Mahal, is a testament to India\'s glorious Mughal past. Once the capital of the Mughal Empire, Agra is home to three UNESCO World Heritage Sites and represents the pinnacle of Mughal architecture and artistry.',
    tagline: 'Where love is immortalized in marble',
    bestTime: 'October to March (ideal for sightseeing and pleasant sunrise views)',
    attractions: [
      'Taj Mahal - One of the Seven Wonders of the World',
      'Agra Fort - Massive red sandstone fort and UNESCO World Heritage Site',
      'Fatehpur Sikri - Abandoned Mughal city 40km from Agra',
      'Itimad-ud-Daulah (Baby Taj) - Exquisite marble mausoleum',
      'Mehtab Bagh - Garden complex offering stunning Taj views',
      'Jama Masjid - One of India\'s largest mosques',
      'Akbar\'s Tomb at Sikandra - Final resting place of Emperor Akbar'
    ],
    facts: [
      'The Taj Mahal took 22 years and 20,000 workers to complete',
      '28 types of precious stones were inlaid into the white marble',
      'The Taj changes color depending on the time of day and season',
      'Agra was the Mughal capital from 1556 to 1658',
      'The city is famous for its marble inlay work (pietra dura)',
      'Over 7-8 million tourists visit Agra annually'
    ],
    thingsToDo: [
      'Watch sunrise at the Taj Mahal for magical light',
      'Visit a marble inlay workshop and see artisans at work',
      'Explore the massive Agra Fort complex',
      'Take sunset photos from Mehtab Bagh across the Yamuna River',
      'Shop for marble souvenirs and leather goods',
      'Try Agra\'s famous petha (sweet delicacy)'
    ],
    howToReach: 'Agra is 230km from Delhi, connected by expressway (3-4 hours by car), regular trains including the Gatimaan Express (100 minutes), and domestic flights.',
    gallery: [
      'https://images.unsplash.com/photo-1524492412937-b28074a5d7da?w=1200&q=85',
      'https://images.unsplash.com/photo-1548013146-72479768bada?crop=entropy&cs=srgb&fm=jpg&q=85',
      'https://images.unsplash.com/photo-1599661046289-e31897846e41?crop=entropy&cs=srgb&fm=jpg&q=85',
      'https://images.unsplash.com/photo-1587135941948-670b381f08ce?crop=entropy&cs=srgb&fm=jpg&q=85'
    ],
    metaTitle: 'Agra Travel Guide - Visit the Taj Mahal & Mughal Heritage | POMTrips',
    metaDescription: 'Experience Agra\'s magnificent Taj Mahal, Agra Fort, and Mughal architecture. Discover the city that immortalized love in marble.'
  },
  {
    id: 3,
    slug: 'rishikesh',
    name: 'Rishikesh',
    description: 'Where stories rise with the mist of the Ganga',
    descriptionEs: 'Donde las historias surgen con la niebla del Ganga',
    image: 'https://images.unsplash.com/photo-1678788166239-b28733f56956?crop=entropy&cs=srgb&fm=jpg&q=85',
    heroImage: 'https://images.unsplash.com/photo-1570804485046-b5b8d795dc5d?crop=entropy&cs=srgb&fm=jpg&q=85',
    overview: 'Nestled in the foothills of the Himalayas along the banks of the sacred Ganges River, Rishikesh is known as the "Yoga Capital of the World." This spiritual town attracts seekers, adventure enthusiasts, and those looking for inner peace in equal measure.',
    tagline: 'Gateway to the Himalayas and path to enlightenment',
    bestTime: 'September to November and February to May (pleasant weather for outdoor activities)',
    attractions: [
      'Laxman Jhula & Ram Jhula - Iconic suspension bridges over the Ganga',
      'Parmarth Niketan Ashram - Largest ashram with evening Ganga Aarti',
      'Beatles Ashram - Where the Beatles stayed in 1968',
      'Triveni Ghat - Main bathing ghat with evening ceremonies',
      'Neer Garh Waterfall - Scenic waterfall perfect for picnics',
      'Rajaji National Park - Wildlife sanctuary at the edge of town',
      'Kunjapuri Temple - Hilltop temple with Himalayan sunrise views'
    ],
    facts: [
      'Rishikesh is considered the birthplace of yoga',
      'The Beatles\' 1968 visit put Rishikesh on the global map',
      'Home to hundreds of yoga ashrams and spiritual centers',
      'The Ganga here is believed to be at its most sacred',
      'Rishikesh is a vegetarian-only and alcohol-free city',
      'It\'s the starting point for the Char Dham Yatra pilgrimage'
    ],
    thingsToDo: [
      'Attend the mesmerizing Ganga Aarti at sunset',
      'Join a yoga teacher training course or drop-in classes',
      'Experience white water rafting on the Ganga',
      'Go bungee jumping at India\'s highest bungee point',
      'Trek to nearby waterfalls and temples',
      'Take a meditation retreat in an ashram',
      'Try cliff jumping and kayaking'
    ],
    howToReach: 'Dehradun Airport (25km away) is the nearest airport. Rishikesh is well-connected by road and rail to Delhi (240km), Haridwar (20km), and other major cities.',
    gallery: [
      'https://images.unsplash.com/photo-1570804485046-b5b8d795dc5d?crop=entropy&cs=srgb&fm=jpg&q=85',
      'https://images.unsplash.com/photo-1678788166239-b28733f56956?crop=entropy&cs=srgb&fm=jpg&q=85',
      'https://images.unsplash.com/photo-1653278443420-505d2b6fbfbd?crop=entropy&cs=srgb&fm=jpg&q=85',
      'https://images.unsplash.com/photo-1758797315487-b3b225dff7d8?crop=entropy&cs=srgb&fm=jpg&q=85'
    ],
    metaTitle: 'Rishikesh Travel Guide - Yoga Capital & Spiritual Retreat | POMTrips',
    metaDescription: 'Discover Rishikesh, the yoga capital of the world. Experience Ganga Aarti, ashram life, adventure sports, and Himalayan serenity on the sacred Ganges.'
  },
  {
    id: 4,
    slug: 'gwalior',
    name: 'Gwalior',
    description: 'Forts that touch the sky, music that touches the soul',
    descriptionEs: 'Fortalezas que tocan el cielo, música que toca el alma',
    image: 'https://customer-assets.emergentagent.com/job_78c28fa2-98c0-4ed4-9e64-bb9cb7262686/artifacts/czk5gyzs_Gwalior%20%281%29.jpg',
    heroImage: 'https://customer-assets.emergentagent.com/job_78c28fa2-98c0-4ed4-9e64-bb9cb7262686/artifacts/czk5gyzs_Gwalior%20%281%29.jpg',
    overview: 'Gwalior is a historic city in Madhya Pradesh, famous for its hilltop fort described as "the pearl among fortresses in India." Rich in cultural heritage, classical music, and architectural marvels, Gwalior offers a glimpse into India\'s royal past.',
    tagline: 'Where music echoes through ancient stones',
    bestTime: 'October to March (comfortable weather for exploring forts and palaces)',
    attractions: [
      'Gwalior Fort - Massive hilltop fortress with 2,000 years of history',
      'Man Singh Palace - Stunning blue-tiled palace within the fort',
      'Sas Bahu Temples - Intricately carved 11th-century temples',
      'Teli Ka Mandir - Unique blend of Dravidian and North Indian architecture',
      'Jai Vilas Palace - Opulent 19th-century palace and museum',
      'Tansen\'s Tomb - Memorial to legendary musician Tansen',
      'Gujari Mahal Archaeological Museum - Houses ancient sculptures'
    ],
    facts: [
      'The Gwalior Fort has been ruled by 84 different rulers',
      'Birthplace of legendary musician Tansen, one of the "Nine Jewels"',
      'The fort\'s Man Singh Palace inspired the design of Leeds Castle',
      'Gwalior is known as the "City of Music" in India',
      'The annual Tansen Music Festival attracts classical musicians worldwide',
      'Some of India\'s oldest rock-cut Jain sculptures are found here'
    ],
    thingsToDo: [
      'Explore the massive Gwalior Fort complex',
      'Attend a classical music concert during Tansen Festival',
      'Visit the opulent Jai Vilas Palace and see the world\'s heaviest chandeliers',
      'Watch the Sound and Light Show at the fort',
      'Explore ancient Jain sculptures carved into cliff faces',
      'Shop for handloom textiles and traditional crafts'
    ],
    howToReach: 'Gwalior has its own airport with flights from Delhi and Mumbai. It\'s also well-connected by rail (319km from Delhi) and road networks.',
    gallery: [
      'https://customer-assets.emergentagent.com/job_78c28fa2-98c0-4ed4-9e64-bb9cb7262686/artifacts/czk5gyzs_Gwalior%20%281%29.jpg',
      'https://customer-assets.emergentagent.com/job_78c28fa2-98c0-4ed4-9e64-bb9cb7262686/artifacts/0xj6bo7q_Gwalior%20%282%29.jpg',
      'https://customer-assets.emergentagent.com/job_78c28fa2-98c0-4ed4-9e64-bb9cb7262686/artifacts/t8goxi6d_Gwalior%20%283%29.jpg',
      'https://customer-assets.emergentagent.com/job_wanderlust-elite/artifacts/u0bmrkbq_20190211_114401_edited.jpg',
      'https://customer-assets.emergentagent.com/job_wanderlust-elite/artifacts/iwu85avh_20190211_114538_edited.jpg',
      'https://customer-assets.emergentagent.com/job_wanderlust-elite/artifacts/o1aupcnx_20190211_102135_edited.jpg'
    ],
    metaTitle: 'Gwalior Travel Guide - Historic Fort & Music Heritage | POMTrips',
    metaDescription: 'Explore Gwalior\'s magnificent fort, palaces, and rich musical heritage. Discover the pearl among India\'s fortresses and birthplace of Tansen.'
  },
  {
    id: 5,
    slug: 'jim-corbett',
    name: 'Jim Corbett National Park',
    description: 'Wild heartbeats echo through ancient forests',
    descriptionEs: 'Latidos salvajes resuenan a través de bosques antiguos',
    image: 'https://images.unsplash.com/photo-1676634694424-2938c2d7da43?crop=entropy&cs=srgb&fm=jpg&q=85',
    heroImage: 'https://images.unsplash.com/photo-1676634694424-2938c2d7da43?crop=entropy&cs=srgb&fm=jpg&q=85',
    overview: 'Jim Corbett National Park, India\'s oldest national park established in 1936, is a haven for Bengal tigers and diverse wildlife. Spread across 520 sq km in Uttarakhand\'s Himalayan foothills, it offers thrilling safaris through sal forests, grasslands, and riverine areas.',
    tagline: 'India\'s first national park and tiger\'s kingdom',
    bestTime: 'November to June (park closed during monsoon July-October)',
    attractions: [
      'Dhikala Zone - Best for tiger sightings with grasslands and forests',
      'Bijrani Zone - Popular zone with good wildlife diversity',
      'Jhirna Zone - Open year-round, excellent for leopards',
      'Corbett Museum - Historic house of Jim Corbett',
      'Garjiya Devi Temple - Riverside temple on a large rock',
      'Kosi River - Flowing through the park, attracts wildlife',
      'Sitabani Forest Reserve - Buffer zone with temple and wildlife'
    ],
    facts: [
      'Home to over 600 species of birds, making it a birdwatcher\'s paradise',
      'The park has approximately 200+ Bengal tigers',
      'Named after legendary hunter-turned-conservationist Jim Corbett',
      'First area in India to come under Project Tiger (1973)',
      'Houses over 50 species of mammals and 25 species of reptiles',
      'Elephants can be spotted in large herds, especially near Dhikala'
    ],
    thingsToDo: [
      'Jeep safari through different zones for tiger spotting',
      'Elephant safari in Bijrani zone',
      'Bird watching early morning (Great Hornbill, Kingfishers)',
      'Nature walks in buffer zones with naturalists',
      'Visit Corbett Museum to learn about conservation history',
      'Photography safaris capturing wildlife and landscapes',
      'Riverside camping and bonfire experiences'
    ],
    howToReach: 'Nearest town is Ramnagar, 245km from Delhi. Pantnagar Airport (80km) or Phoolbagh Airport in Ramnagar. Accessible by road via Moradabad-Ramnagar route.',
    gallery: [
      'https://images.unsplash.com/photo-1676634694424-2938c2d7da43?crop=entropy&cs=srgb&fm=jpg&q=85',
      'https://images.pexels.com/photos/29666820/pexels-photo-29666820.png?auto=compress&cs=tinysrgb&w=800',
      'https://images.unsplash.com/photo-1549366021-9f761d450615?crop=entropy&cs=srgb&fm=jpg&q=85',
      'https://images.unsplash.com/photo-1524492412937-b28074a5d7da?w=1200&q=85'
    ],
    metaTitle: 'Jim Corbett National Park Guide - Tiger Safari & Wildlife | POMTrips',
    metaDescription: 'Experience India\'s oldest national park. Spot Bengal tigers, elephants, and 600+ bird species in thrilling jeep safaris through pristine forests.'
  },
  {
    id: 6,
    slug: 'chambal-safari',
    name: 'Chambal Safari',
    description: 'Where gharials glide through untamed waters',
    descriptionEs: 'Donde los gaviales se deslizan por aguas indómitas',
    image: 'https://images.unsplash.com/photo-1572403490139-e08bf9689937?crop=entropy&cs=srgb&fm=jpg&q=85',
    heroImage: 'https://images.unsplash.com/photo-1572403490139-e08bf9689937?crop=entropy&cs=srgb&fm=jpg&q=85',
    overview: 'The Chambal River Safari offers a unique opportunity to explore one of India\'s cleanest and most pristine rivers. The National Chambal Sanctuary is home to critically endangered gharials (fish-eating crocodiles), Gangetic dolphins, and over 320 bird species.',
    tagline: 'India\'s cleanest river and haven for rare species',
    bestTime: 'October to March (ideal for boat safaris and wildlife viewing)',
    attractions: [
      'National Chambal Sanctuary - Pristine river ecosystem',
      'Gharial spotting - See critically endangered crocodiles',
      'Gangetic Dolphin sightings - Rare freshwater dolphins',
      'Migratory bird watching - Over 320 species',
      'Bateshwar Temples - Ancient riverside temple complex',
      'Riverside ravines - Unique geological formations',
      'Fishing villages - Traditional river communities'
    ],
    facts: [
      'Home to 70% of India\'s gharial population',
      'One of the last remaining habitats of Gangetic dolphins',
      'The Chambal River flows through three states - MP, Rajasthan, UP',
      'Sanctuary spans 5,400 sq km along 425 km of the river',
      'Declared a sanctuary in 1979 for gharial conservation',
      'Ravines provide refuge to various endangered species'
    ],
    thingsToDo: [
      'Boat safari to spot gharials and dolphins',
      'Bird watching tours (Sarus Crane, Indian Skimmer)',
      'Photography of unique river landscapes',
      'Visit Bateshwar temple complex (101 ancient Shiva temples)',
      'Explore the dramatic ravine landscapes',
      'Interact with local fishing communities',
      'Sunset boat rides on the pristine river'
    ],
    howToReach: 'Access points include Agra (70km), Dholpur (Rajasthan), and Etawah (UP). Best accessed via road from Agra or combined with Agra tour.',
    gallery: [
      'https://images.unsplash.com/photo-1572403490139-e08bf9689937?crop=entropy&cs=srgb&fm=jpg&q=85',
      'https://images.unsplash.com/photo-1676744846995-16b700a00d57?crop=entropy&cs=srgb&fm=jpg&q=85',
      'https://images.unsplash.com/photo-1600261669797-1bb7b27939be?crop=entropy&cs=srgb&fm=jpg&q=85',
      'https://images.unsplash.com/photo-1549366021-9f761d450615?crop=entropy&cs=srgb&fm=jpg&q=85'
    ],
    metaTitle: 'Chambal Safari Guide - Gharials, Dolphins & River Wildlife | POMTrips',
    metaDescription: 'Explore India\'s cleanest river on a Chambal Safari. Spot endangered gharials, Gangetic dolphins, and 320+ bird species in pristine natural habitat.'
  }
];

export const testimonials = [
  {
    id: 1,
    quote: 'I felt totally safe with him during the whole time as a solo female traveller. I highly recommend him.',
    quoteEs: 'Me sentí totalmente segura con él durante todo el tiempo como viajera solitaria. Lo recomiendo ampliamente.',
    author: 'Daniella',
    role: 'Traveller',
    roleEs: 'Viajera',
    location: 'Cardiff, United Kingdom',
    locationEs: 'Cardiff, Reino Unido',
    image: 'https://customer-assets.emergentagent.com/job_wanderlust-elite/artifacts/jvnsbqu6_Daniella-UK.jpg'
  },
  {
    id: 2,
    quote: 'We are glad to find Manish! He was super attentive to our needs. The trip was super smooth, the driver was great. We experienced fast track to Taj Mahal avoiding merchandises, pickpockets and learnt about Taj Mahal. Definitely recommend him as a guide and as an organiser.',
    quoteEs: '¡Estamos contentos de encontrar a Manish! Fue muy atento a nuestras necesidades. El viaje fue muy fluido, el conductor fue genial. Experimentamos acceso rápido al Taj Mahal evitando vendedores, carteristas y aprendimos sobre el Taj Mahal.',
    author: 'Anna',
    role: 'Traveller',
    roleEs: 'Viajera',
    location: 'Russia',
    locationEs: 'Rusia',
    image: 'https://customer-assets.emergentagent.com/job_wanderlust-elite/artifacts/bx2gr4pp_Anna-Russia.jpg'
  },
  {
    id: 3,
    quote: 'Manish was great! We asked for a tour of Delhi that would take us to many places that the normal tours would not and he did not disappoint! We really appreciated the laid back attitude and his ability to understand what we were looking for.',
    quoteEs: '¡Manish fue genial! Pedimos un tour de Delhi que nos llevara a muchos lugares que los tours normales no ofrecían y no nos decepcionó. Apreciamos mucho su actitud relajada y su capacidad para entender lo que buscábamos.',
    author: 'Steve Douge',
    role: 'US Air Force',
    roleEs: 'Fuerza Aérea de EE.UU.',
    location: 'USA',
    locationEs: 'EE.UU.',
    image: 'https://customer-assets.emergentagent.com/job_wanderlust-elite/artifacts/dhhoat01_Steve%20Douge-USA.jpg'
  },
  {
    id: 4,
    quote: 'I had a really great day with Manish, we took a ride on his scooter and went across town in an unbelievable adventure trying out amazing food and finding a sweet spot to take pictures on the roof.',
    quoteEs: 'Tuve un día realmente genial con Manish, tomamos un paseo en su scooter y recorrimos la ciudad en una aventura increíble probando comida increíble y encontrando un lugar dulce para tomar fotos en el techo.',
    author: 'Dan',
    role: 'Traveller',
    roleEs: 'Viajero',
    location: 'Croatia',
    locationEs: 'Croacia',
    image: 'https://customer-assets.emergentagent.com/job_wanderlust-elite/artifacts/oaaresim_Dan-Croatia.jpg'
  },
  {
    id: 5,
    quote: 'Manish is THE BEST! If you are looking for the best guide in Delhi you have found him. I had very specific requests for my itinerary and he went above and beyond to find the best places I was looking for and to experience the best of the best!',
    quoteEs: '¡Manish es EL MEJOR! Si estás buscando el mejor guía en Delhi, lo has encontrado. Tenía solicitudes muy específicas para mi itinerario y él fue más allá para encontrar los mejores lugares que buscaba.',
    author: 'Bobby',
    role: 'Famous YouTuber',
    roleEs: 'YouTuber Famoso',
    location: 'USA',
    locationEs: 'EE.UU.',
    image: 'https://customer-assets.emergentagent.com/job_wanderlust-elite/artifacts/a7qkj717_Bobby%20USA.png'
  },
  {
    id: 6,
    quote: 'Manish was a superb guide. His knowledge and his ability to organise on the spur of the moment was a great example to how guides should be. Him and his assistant were very pleasant to be with and made us feel at home. Thank you very much POMtrips!',
    quoteEs: 'Manish fue un guía excelente. Su conocimiento y su capacidad para organizar sobre la marcha fue un gran ejemplo de cómo deben ser los guías. Él y su asistente fueron muy agradables y nos hicieron sentir como en casa.',
    author: 'Christopher',
    role: 'DJ',
    roleEs: 'DJ',
    location: 'Malta',
    locationEs: 'Malta',
    image: 'https://customer-assets.emergentagent.com/job_wanderlust-elite/artifacts/mod9y3p4_Christopher-Malta.jpg'
  },
  {
    id: 7,
    quote: 'Manish was an excellent guide. His wide knowledge of Indian history and information is really good. He personalized the tour for me according to my requirements and went above and beyond to ensure I had a good time. Great tour and wonderful companion!',
    quoteEs: 'Manish fue un guía excelente. Su amplio conocimiento de la historia e información de India es realmente bueno. Personalizó el tour para mí según mis requisitos y fue más allá para asegurar que pasara un buen momento.',
    author: 'Misbah',
    role: 'Explorer',
    roleEs: 'Explorador',
    location: 'Maldives',
    locationEs: 'Maldivas',
    image: 'https://customer-assets.emergentagent.com/job_wanderlust-elite/artifacts/5zpvbuwe_Misbah-Maldives.jpg'
  },
  {
    id: 8,
    quote: 'Amazing Manish! He is not only care-taking but really makes sure your trip with him is excellent. Traveling with him is more like with a friend than with a "guide" - you will definitely enjoy the time together!',
    quoteEs: '¡Increíble Manish! No solo es atento, sino que realmente se asegura de que tu viaje con él sea excelente. Viajar con él es más como con un amigo que con un "guía".',
    author: 'Sascha',
    role: 'Photographer',
    roleEs: 'Fotógrafo',
    location: 'Austria',
    locationEs: 'Austria',
    image: 'https://customer-assets.emergentagent.com/job_wanderlust-elite/artifacts/3icnpbqv_Sascha-Austria.jpg'
  },
  {
    id: 9,
    quote: 'During the FIFA U-17 World Cup 2017 hosted in India, Peace of Mind Trips & Travels had the privilege of assisting the Colombia U-17 National Football Team. We curated a seamless and memorable trip to the Taj Mahal and key landmarks of Delhi.',
    quoteEs: 'Durante la Copa Mundial Sub-17 de la FIFA 2017 organizada en India, Peace of Mind Trips & Travels tuvo el privilegio de asistir al equipo nacional de fútbol Sub-17 de Colombia. Organizamos un viaje sin problemas y memorable al Taj Mahal.',
    author: 'U-17 FIFA Team Colombia',
    role: 'National Football Team',
    roleEs: 'Selección Nacional de Fútbol',
    location: 'Colombia',
    locationEs: 'Colombia',
    image: 'https://customer-assets.emergentagent.com/job_wanderlust-elite/artifacts/3em7jriw_u-17%20foot%20team%20colombia%20FIFA.png'
  },
  {
    id: 10,
    quote: 'POMTT proudly supported Eurodata Sport and Team Colombia during the FIFA U-17 World Cup 2017 in India, managing their logistics, transportation, and a curated Taj Mahal experience.',
    quoteEs: 'POMTT apoyó con orgullo a Eurodata Sport y al equipo de Colombia durante la Copa Mundial Sub-17 de la FIFA 2017 en India, gestionando su logística, transporte y una experiencia curada del Taj Mahal.',
    author: 'Eurodata Sport',
    role: 'Sports Management',
    roleEs: 'Gestión Deportiva',
    location: 'London, UK',
    locationEs: 'Londres, Reino Unido',
    image: 'https://customer-assets.emergentagent.com/job_wanderlust-elite/artifacts/50onq578_Eurodata%20sport%20logo.jpg'
  }
];

// Heritage Walks Data
export const heritageWalks = [
  {
    id: 1,
    slug: 'old-delhi-food',
    name: 'Old Delhi Food & Heritage Walk',
    nameEs: 'Paseo Gastronómico y Patrimonial por Old Delhi',
    tagline: 'Taste centuries of culinary heritage',
    taglineEs: 'Prueba siglos de herencia culinaria',
    duration: '4 hours',
    durationEs: '4 horas',
    heroImage: 'https://customer-assets.emergentagent.com/job_78c28fa2-98c0-4ed4-9e64-bb9cb7262686/artifacts/o91lpwp8_20170516_Old%20Delhi%20%282%29.jpg',
    summary: 'Dive into the narrow lanes of Old Delhi on a sensory journey through 400 years of Mughal culinary traditions. This walking tour combines heritage architecture with authentic street food tastings, taking you through Chandni Chowk\'s bustling markets, Jama Masjid, and the legendary Paranthe Wali Gali.',
    summaryEs: 'Sumérgete en los estrechos callejones de Old Delhi en un viaje sensorial a través de 400 años de tradiciones culinarias mogolas.',
    highlights: [
      'Chandni Chowk market exploration with spice vendors',
      'Paranthe Wali Gali - Famous lane of fried breads since 1872',
      'Jama Masjid courtyard and architecture tour',
      'Traditional sweet shops and kulfi (Indian ice cream)',
      'Khari Baoli - Asia\'s largest spice market',
      '8-10 food tastings including vegetarian and non-vegetarian options'
    ],
    highlightsEs: [
      'Exploración del mercado Chandni Chowk',
      'Paranthe Wali Gali - Callejón famoso de panes fritos desde 1872',
      'Tour del patio y arquitectura de Jama Masjid',
      'Tiendas tradicionales de dulces y kulfi',
      'Khari Baoli - El mercado de especias más grande de Asia',
      '8-10 degustaciones de comida'
    ],
    route: 'Starts at Chandni Chowk Metro → Paranthe Wali Gali → Jama Masjid → Spice Market → Sweet shops → Ends at Chandni Chowk Metro',
    routeEs: 'Comienza en Metro Chandni Chowk → Paranthe Wali Gali → Jama Masjid → Mercado de Especias → Tiendas de dulces → Termina en Metro Chandni Chowk',
    inclusions: [
      'Expert local guide',
      '8-10 food tastings',
      'Bottled water',
      'All entrance fees',
      'Small group (max 8 people)'
    ],
    gallery: [
      {
        url: 'https://customer-assets.emergentagent.com/job_78c28fa2-98c0-4ed4-9e64-bb9cb7262686/artifacts/jnv8o8dd_Dehi%20heritage%20walk%20%281%29.jpg',
        alt: 'Old Delhi Food Walk — Chandni Chowk streets — Peace of Mind Trips',
        caption: 'Bustling lanes of Chandni Chowk'
      },
      {
        url: 'https://customer-assets.emergentagent.com/job_78c28fa2-98c0-4ed4-9e64-bb9cb7262686/artifacts/7zfosbyb_Dehi%20heritage%20walk%20%282%29.jpg',
        alt: 'Old Delhi Food Walk — Street food preparation — Peace of Mind Trips',
        caption: 'Traditional street food scene'
      },
      {
        url: 'https://customer-assets.emergentagent.com/job_78c28fa2-98c0-4ed4-9e64-bb9cb7262686/artifacts/jm2mkcgu_Dehi%20heritage%20walk%20%284%29.jpg',
        alt: 'Old Delhi Food Walk — Spice market colors — Peace of Mind Trips',
        caption: 'Vibrant Delhi heritage'
      },
      {
        url: 'https://images.unsplash.com/photo-1601050690597-df0568f70950?w=1200&q=85',
        alt: 'Old Delhi Food Walk — Heritage architecture — Peace of Mind Trips',
        caption: 'Old Delhi heritage buildings'
      },
      {
        url: 'https://images.unsplash.com/photo-1603894584373-5ac82b2ae398?w=1200&q=85',
        alt: 'Old Delhi Food Walk — Rickshaw ride — Peace of Mind Trips',
        caption: 'Rickshaw through narrow lanes'
      }
    ],
    metaTitle: 'Old Delhi Food & Heritage Walk | POMTrips Heritage Walks',
    metaDescription: 'Explore Old Delhi\'s culinary heritage on a 4-hour walking tour through Chandni Chowk, Jama Masjid, and spice markets with 8+ food tastings.'
  },
  {
    id: 2,
    slug: 'lodhi-art-district',
    name: 'Lodhi Art District Walk',
    nameEs: 'Paseo por el Distrito de Arte Lodhi',
    tagline: 'Where street art meets history',
    taglineEs: 'Donde el arte callejero se encuentra con la historia',
    duration: '3 hours',
    durationEs: '3 horas',
    heroImage: 'https://customer-assets.emergentagent.com/job_wanderlust-elite/artifacts/oodvdsd8_20231127_161405_edited.jpg',
    summary: 'Discover India\'s first open-air public art district in the heart of Delhi. This contemporary walk showcases stunning street murals by international and Indian artists, interspersed with historic Lodhi-era tombs dating back to the 15th century. Experience where ancient heritage meets modern artistic expression.',
    summaryEs: 'Descubre el primer distrito de arte público al aire libre de India en el corazón de Delhi. Este paseo contemporáneo muestra impresionantes murales callejeros.',
    highlights: [
      '25+ large-scale street art murals by international artists',
      'Historic Lodhi Gardens and 15th-century tombs',
      'Photography opportunities at every corner',
      'Visit to contemporary art galleries',
      'Café culture and artisan coffee shops',
      'Stories behind each mural and artist'
    ],
    highlightsEs: [
      'Más de 25 murales de arte callejero a gran escala',
      'Jardines históricos de Lodhi y tumbas del siglo XV',
      'Oportunidades fotográficas en cada esquina',
      'Visita a galerías de arte contemporáneo',
      'Cultura de cafés',
      'Historias detrás de cada mural'
    ],
    route: 'Starts at Lodhi Colony → Street art murals → Lodhi Gardens → Art galleries → Cafés → Ends at Lodhi Colony',
    routeEs: 'Comienza en Colonia Lodhi → Murales de arte callejero → Jardines Lodhi → Galerías de arte → Cafés → Termina en Colonia Lodhi',
    inclusions: [
      'Art historian guide',
      'All photography rights',
      'Garden entrance',
      'Coffee/tea at local café',
      'Small group (max 10 people)'
    ],
    gallery: [
      {
        url: 'https://customer-assets.emergentagent.com/job_wanderlust-elite/artifacts/oodvdsd8_20231127_161405_edited.jpg',
        alt: 'Lodhi Art District Walk — Street art mural — Peace of Mind Trips',
        caption: 'Vibrant street art in Lodhi Colony'
      },
      {
        url: 'https://customer-assets.emergentagent.com/job_wanderlust-elite/artifacts/ebz8aej1_20220228_080938_edited.jpg',
        alt: 'Lodhi Art District Walk — Contemporary art — Peace of Mind Trips',
        caption: 'Contemporary murals'
      },
      {
        url: 'https://customer-assets.emergentagent.com/job_wanderlust-elite/artifacts/xgkbuuek_16%29_Ode%20to%20Femininity%E2%80%9D%20by%20Sajid%20Wajid%20Sheik%28India%29%20%284%29-2_edited.jpg',
        alt: 'Lodhi Art District Walk — Ode to Femininity mural — Peace of Mind Trips',
        caption: 'Ode to Femininity by Sajid Wajid Sheik'
      }
    ],
    metaTitle: 'Lodhi Art District Walk — Street Art & Heritage | POMTrips',
    metaDescription: 'Explore Delhi\'s first public art district with 25+ street murals, historic Lodhi Gardens, and contemporary galleries on this 3-hour guided walk.'
  },
  {
    id: 3,
    slug: 'unity-in-diversity',
    name: 'Unity in Diversity: Religious & Cultural Walk',
    nameEs: 'Unidad en la Diversidad: Paseo Religioso y Cultural',
    tagline: 'Experience India\'s spiritual harmony',
    taglineEs: 'Experimenta la armonía espiritual de India',
    duration: '4 hours',
    durationEs: '4 horas',
    heroImage: 'https://customer-assets.emergentagent.com/job_wanderlust-elite/artifacts/35xvn74e_20230205_153836_edited.jpg',
    summary: 'Journey through India\'s incredible religious diversity on this respectful walking tour visiting Hindu temples, Sikh Gurudwaras, Islamic mosques, and Christian churches. Experience how different faiths coexist harmoniously in the heart of Delhi, sharing stories of tolerance, tradition, and community.',
    summaryEs: 'Viaja a través de la increíble diversidad religiosa de India en este respetuoso paseo visitando templos hindúes, Gurudwaras sijs, mezquitas islámicas e iglesias cristianas.',
    highlights: [
      'Gurudwara Bangla Sahib - Sikh temple with community kitchen',
      'Jama Masjid - India\'s largest mosque',
      'Hanuman Temple - Ancient Hindu temple',
      'Sacred Heart Cathedral - Historic church',
      'Respectful interfaith dialogue and learning',
      'Langar (community meal) experience at Gurudwara'
    ],
    highlightsEs: [
      'Gurudwara Bangla Sahib - Templo sij con cocina comunitaria',
      'Jama Masjid - La mezquita más grande de India',
      'Templo Hanuman - Antiguo templo hindú',
      'Catedral del Sagrado Corazón - Iglesia histórica',
      'Diálogo interreligioso respetuoso',
      'Experiencia de Langar (comida comunitaria)'
    ],
    route: 'Starts at Hanuman Temple → Gurudwara Bangla Sahib → Jama Masjid → Sacred Heart Cathedral → Ends near Connaught Place',
    routeEs: 'Comienza en Templo Hanuman → Gurudwara Bangla Sahib → Jama Masjid → Catedral del Sagrado Corazón → Termina cerca de Connaught Place',
    inclusions: [
      'Expert cultural guide',
      'All entrance fees',
      'Head coverings provided where required',
      'Langar meal at Gurudwara',
      'Respectful protocol guidance',
      'Small group (max 8 people)'
    ],
    gallery: [
      {
        url: 'https://customer-assets.emergentagent.com/job_wanderlust-elite/artifacts/35xvn74e_20230205_153836_edited.jpg',
        alt: 'Unity in Diversity Walk — Heritage site — Peace of Mind Trips',
        caption: 'Heritage and culture'
      },
      {
        url: 'https://customer-assets.emergentagent.com/job_wanderlust-elite/artifacts/97o4ivoh_Himmy%20collage_edited.jpg',
        alt: 'Unity in Diversity Walk — Group collage — Peace of Mind Trips',
        caption: 'Unity in Diversity experience'
      },
      {
        url: 'https://customer-assets.emergentagent.com/job_wanderlust-elite/artifacts/1jpjwzug_IMG-20191202-WA0106_edited.jpg',
        alt: 'Unity in Diversity Walk — Travelers at religious site — Peace of Mind Trips',
        caption: 'Exploring religious harmony'
      },
      {
        url: 'https://customer-assets.emergentagent.com/job_wanderlust-elite/artifacts/ff1ntn47_20211113_094012_edited.jpg',
        alt: 'Unity in Diversity Walk — Temple visit — Peace of Mind Trips',
        caption: 'Temple exploration'
      },
      {
        url: 'https://customer-assets.emergentagent.com/job_wanderlust-elite/artifacts/uchfome9_20211113_100647_edited.jpg',
        alt: 'Unity in Diversity Walk — Cultural experience — Peace of Mind Trips',
        caption: 'Cultural immersion'
      },
      {
        url: 'https://customer-assets.emergentagent.com/job_wanderlust-elite/artifacts/uvxvy8aa_IMG-20230224-WA0011_edited.jpg',
        alt: 'Unity in Diversity Walk — Group at temple — Peace of Mind Trips',
        caption: 'Temple visit experience'
      },
      {
        url: 'https://customer-assets.emergentagent.com/job_wanderlust-elite/artifacts/8z37zycw_20231127_114034_edited.jpg',
        alt: 'Unity in Diversity Walk — Religious site exploration — Peace of Mind Trips',
        caption: 'Discovering religious harmony'
      },
      {
        url: 'https://customer-assets.emergentagent.com/job_wanderlust-elite/artifacts/wrdogkoy_20221211_101757_edited.jpg',
        alt: 'Unity in Diversity Walk — Heritage walk — Peace of Mind Trips',
        caption: 'Heritage walk experience'
      },
      {
        url: 'https://customer-assets.emergentagent.com/job_wanderlust-elite/artifacts/ieqvpz92_d66aed_68f0da79bc414c35baaaff9bbb188adf~mv2.jpg',
        alt: 'Unity in Diversity Walk — Cultural journey — Peace of Mind Trips',
        caption: 'Cultural journey through Delhi'
      }
    ],
    metaTitle: 'Unity in Diversity Walk — Religious & Cultural Tour Delhi | POMTrips',
    metaDescription: 'Experience Delhi\'s religious harmony visiting Hindu temples, Sikh Gurudwaras, mosques, and churches. Respectful 4-hour guided interfaith walk.'
  }
];

export const whyChooseReasons = [
  {
    id: 1,
    title: 'Transparency',
    titleEs: 'Transparencia',
    description: 'Clear pricing, no hidden costs',
    descriptionEs: 'Precios claros, sin costos ocultos',
    icon: 'shield-check'
  },
  {
    id: 2,
    title: 'Handmade Itineraries',
    titleEs: 'Itinerarios Hechos a Mano',
    description: 'Personalized journeys crafted for you',
    descriptionEs: 'Viajes personalizados creados para ti',
    icon: 'map'
  },
  {
    id: 3,
    title: 'Virtual Tours',
    titleEs: 'Tours Virtuales',
    description: 'Experience India from anywhere',
    descriptionEs: 'Experimenta India desde cualquier lugar',
    icon: 'globe'
  },
  {
    id: 4,
    title: 'Solo Traveler Friendly',
    titleEs: 'Amigable para Viajeros Solos',
    description: 'Safe, welcoming, transformative',
    descriptionEs: 'Seguro, acogedor, transformador',
    icon: 'user'
  }
];

// Detailed Tours Data
export const tours = [
  {
    id: 1,
    slug: 'little-india-heritage-tour',
    name: 'Little India Heritage Tour',
    nameEs: 'Tour del Patrimonio de la Pequeña India',
    metaTitle: 'Delhi Heritage Walk & City Experience | Peace of Mind Trips',
    metaDescription: 'Explore Delhi\'s history, culture, food, and local life through immersive heritage walks and city experiences with Peace of Mind Trips.',
    tagline: 'Walk through centuries of culture, craftsmanship, and soul',
    taglineEs: 'Camina a través de siglos de cultura, artesanía y alma',
    duration: '6 Days',
    durationEs: '6 Días',
    category: 'heritage',
    heroImage: 'https://images.unsplash.com/photo-1524492412937-b28074a5d7da?w=1200&q=85',
    heroVideo: null,
    summary: 'Immerse yourself in India\'s rich cultural tapestry with our Little India Heritage Tour. From the bustling streets of Old Delhi to the timeless beauty of the Taj Mahal, this journey takes you through architectural marvels, ancient traditions, and the vibrant energy of India\'s heritage cities.',
    summaryEs: 'Sumérgete en el rico tapiz cultural de India con nuestro Tour del Patrimonio de la Pequeña India. Desde las bulliciosas calles de Old Delhi hasta la belleza atemporal del Taj Mahal, este viaje te lleva a través de maravillas arquitectónicas, tradiciones antiguas y la vibrante energía de las ciudades patrimoniales de India.',
    highlights: [
      'Private sunrise viewing at the Taj Mahal',
      'Heritage walk through Old Delhi with local guide',
      'Traditional inlay art workshop in Agra',
      'Vintage rickshaw ride through Chandni Chowk',
      'Authentic home-cooked meal with local family',
      'Visit to UNESCO World Heritage Sites'
    ],
    highlightsEs: [
      'Vista privada del amanecer en el Taj Mahal',
      'Paseo patrimonial por Old Delhi con guía local',
      'Taller de arte de incrustación tradicional en Agra',
      'Paseo en rickshaw vintage por Chandni Chowk',
      'Comida casera auténtica con familia local',
      'Visita a Sitios del Patrimonio Mundial de la UNESCO'
    ],
    itinerary: [
      {
        day: 1,
        title: 'Arrival in Delhi',
        titleEs: 'Llegada a Delhi',
        description: 'Welcome briefing at your heritage hotel, evening heritage walk through Old Delhi, optional Aarti ceremony viewing at Jama Masjid',
        descriptionEs: 'Briefing de bienvenida en tu hotel patrimonial, paseo vespertino por Old Delhi, ceremonia opcional de Aarti en Jama Masjid'
      },
      {
        day: 2,
        title: 'Discover Old Delhi',
        titleEs: 'Descubre Old Delhi',
        description: 'Morning rickshaw ride through Chandni Chowk, spice market exploration, Red Fort visit, lunch with a local family, afternoon at India Gate and Lotus Temple',
        descriptionEs: 'Paseo matutino en rickshaw por Chandni Chowk, exploración del mercado de especias, visita al Fuerte Rojo, almuerzo con una familia local, tarde en India Gate y Templo del Loto'
      },
      {
        day: 3,
        title: 'Delhi to Agra',
        titleEs: 'Delhi a Agra',
        description: 'Drive to Agra (approx. 3-4 hours), check-in at heritage property, afternoon inlay art workshop with local artisans, sunset view of Taj Mahal from Mehtab Bagh',
        descriptionEs: 'Viaje a Agra (aprox. 3-4 horas), check-in en propiedad patrimonial, taller de arte de incrustación por la tarde con artesanos locales, vista del atardecer del Taj Mahal desde Mehtab Bagh'
      },
      {
        day: 4,
        title: 'Taj Mahal & Agra Fort',
        titleEs: 'Taj Mahal y Fuerte de Agra',
        description: 'Pre-dawn departure for private Taj Mahal sunrise viewing, breakfast at hotel, visit to Agra Fort, explore local marble workshops, evening at leisure',
        descriptionEs: 'Salida antes del amanecer para ver el amanecer privado del Taj Mahal, desayuno en el hotel, visita al Fuerte de Agra, exploración de talleres de mármol locales, tarde libre'
      },
      {
        day: 5,
        title: 'Gwalior Heritage',
        titleEs: 'Patrimonio de Gwalior',
        description: 'Day trip to Gwalior Fort, explore the stunning palaces and temples, visit to Scindia Museum, return to Agra for final evening',
        descriptionEs: 'Excursión de un día al Fuerte de Gwalior, exploración de impresionantes palacios y templos, visita al Museo Scindia, regreso a Agra para la última tarde'
      },
      {
        day: 6,
        title: 'Departure',
        titleEs: 'Salida',
        description: 'Leisure morning, optional shopping for marble souvenirs, transfer to Delhi or Agra airport for onward journey',
        descriptionEs: 'Mañana libre, compras opcionales de recuerdos de mármol, traslado al aeropuerto de Delhi o Agra para continuar el viaje'
      }
    ],
    inclusions: [
      'Accommodation in heritage hotels (5 nights)',
      'Daily breakfast and 3 lunches',
      'All transfers in private air-conditioned vehicle',
      'English-speaking local guides',
      'Monument entrance fees',
      'Inlay art workshop',
      'Rickshaw rides',
      'Home-cooked meal experience'
    ],
    inclusionsEs: [
      'Alojamiento en hoteles patrimoniales (5 noches)',
      'Desayuno diario y 3 almuerzos',
      'Todos los traslados en vehículo privado con aire acondicionado',
      'Guías locales de habla inglesa',
      'Tarifas de entrada a monumentos',
      'Taller de arte de incrustación',
      'Paseos en rickshaw',
      'Experiencia de comida casera'
    ],
    exclusions: [
      'International flights',
      'Visa fees',
      'Travel insurance',
      'Dinners (except where specified)',
      'Personal expenses',
      'Gratuities',
      'Camera fees at monuments'
    ],
    exclusionsEs: [
      'Vuelos internacionales',
      'Tarifas de visa',
      'Seguro de viaje',
      'Cenas (excepto donde se especifique)',
      'Gastos personales',
      'Propinas',
      'Tarifas de cámara en monumentos'
    ],
    pricing: {
      showPrice: false, // CMS toggle: Show/hide numeric price
      basePrice: 850, // Hidden from UI, kept for internal reference
      currency: 'USD',
      perPerson: true,
      groupDiscount: 'Groups of 4+: 10% discount',
      groupDiscountEs: 'Grupos de 4+: 10% de descuento',
      note: 'Price varies by season and accommodation choice',
      noteEs: 'El precio varía según la temporada y la elección del alojamiento'
    },
    gallery: [
      {
        url: 'https://images.unsplash.com/photo-1524492412937-b28074a5d7da?w=1200&q=85',
        alt: 'Little India Heritage Tour — Taj Mahal at sunrise — Peace of Mind Trips and Travels',
        caption: 'Taj Mahal at sunrise'
      },
      {
        url: 'https://customer-assets.emergentagent.com/job_78c28fa2-98c0-4ed4-9e64-bb9cb7262686/artifacts/1nb4ohfa_20190218_104313.jpg',
        alt: 'Little India Heritage Tour — Taj Mahal gardens — Peace of Mind Trips and Travels',
        caption: 'Taj Mahal and gardens'
      },
      {
        url: 'https://images.unsplash.com/photo-1587474260584-136574528ed5?w=1200&q=85',
        alt: 'Little India Heritage Tour — India Gate sunset — Peace of Mind Trips and Travels',
        caption: 'India Gate at sunset'
      },
      {
        url: 'https://customer-assets.emergentagent.com/job_78c28fa2-98c0-4ed4-9e64-bb9cb7262686/artifacts/japk6neh_Delhi%20monuments%20%281%29.jpg',
        alt: 'Little India Heritage Tour — Delhi monuments — Peace of Mind Trips and Travels',
        caption: 'Delhi heritage monuments'
      },
      {
        url: 'https://customer-assets.emergentagent.com/job_78c28fa2-98c0-4ed4-9e64-bb9cb7262686/artifacts/lds3jfjt_Delhi%20monuments%20%282%29.jpg',
        alt: 'Little India Heritage Tour — Delhi historic sites — Peace of Mind Trips and Travels',
        caption: 'Exploring Delhi heritage'
      },
      {
        url: 'https://customer-assets.emergentagent.com/job_78c28fa2-98c0-4ed4-9e64-bb9cb7262686/artifacts/czk5gyzs_Gwalior%20%281%29.jpg',
        alt: 'Little India Heritage Tour — Gwalior Fort — Peace of Mind Trips and Travels',
        caption: 'Gwalior Fort majesty'
      },
      {
        url: 'https://customer-assets.emergentagent.com/job_78c28fa2-98c0-4ed4-9e64-bb9cb7262686/artifacts/0xj6bo7q_Gwalior%20%282%29.jpg',
        alt: 'Little India Heritage Tour — Gwalior palace interiors — Peace of Mind Trips and Travels',
        caption: 'Gwalior palace details'
      }
    ],
    faqs: [
      {
        question: 'What is the best time to visit?',
        questionEs: '¿Cuál es el mejor momento para visitar?',
        answer: 'October to March offers pleasant weather. We recommend avoiding peak summer (April-June).',
        answerEs: 'De octubre a marzo ofrece un clima agradable. Recomendamos evitar el pico del verano (abril-junio).'
      },
      {
        question: 'Is this tour suitable for solo travelers?',
        questionEs: '¿Este tour es adecuado para viajeros solitarios?',
        answer: 'Absolutely! We welcome solo travelers and can arrange single accommodation. Many of our guests travel solo.',
        answerEs: '¡Absolutamente! Damos la bienvenida a viajeros solitarios y podemos organizar alojamiento individual. Muchos de nuestros huéspedes viajan solos.'
      },
      {
        question: 'What fitness level is required?',
        questionEs: '¿Qué nivel de condición física se requiere?',
        answer: 'Moderate fitness is sufficient. Tours involve walking but at a comfortable pace with breaks.',
        answerEs: 'Una condición física moderada es suficiente. Los tours involucran caminatas pero a un ritmo cómodo con descansos.'
      }
    ],
    metaTitle: 'Little India Heritage Tour - 6 Days | POMTrips',
    metaDescription: 'Explore India\'s rich heritage through Delhi, Agra, and Gwalior. Private Taj Mahal sunrise, heritage walks, artisan workshops, and authentic cultural experiences.',
    relatedTours: [2, 3]
  },
  {
    id: 2,
    slug: 'rishikesh-yoga-wellness-retreat',
    name: 'Rishikesh Yoga & Wellness Retreat',
    nameEs: 'Retiro de Yoga y Bienestar en Rishikesh',
    metaTitle: 'Rishikesh Yoga & Wellness Retreat | Peace of Mind Trips',
    metaDescription: 'Reconnect with yourself in Rishikesh through yoga, meditation, nature, and spiritual experiences curated by Peace of Mind Trips.',
    tagline: 'Find peace by the sacred Ganga',
    taglineEs: 'Encuentra la paz junto al sagrado Ganga',
    duration: '7 Days',
    durationEs: '7 Días',
    category: 'wellness',
    heroImage: 'https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=1200&q=85',
    heroVideo: null,
    summary: 'Reconnect with your inner self on the banks of the holy Ganga River in Rishikesh. This transformative wellness retreat combines daily yoga sessions, meditation, Ayurvedic treatments, and spiritual experiences to rejuvenate mind, body, and soul.',
    summaryEs: 'Reconéctate con tu yo interior en las orillas del sagrado río Ganga en Rishikesh. Este transformador retiro de bienestar combina sesiones diarias de yoga, meditación, tratamientos ayurvédicos y experiencias espirituales para rejuvenecer mente, cuerpo y alma.',
    highlights: [
      'Daily yoga and meditation sessions',
      'Ayurvedic consultation and treatments',
      'Ganga Aarti ceremony at sunset',
      'Sound healing and pranayama workshops',
      'Himalayan nature walks',
      'Satvik vegetarian meals'
    ],
    highlightsEs: [
      'Sesiones diarias de yoga y meditación',
      'Consulta y tratamientos ayurvédicos',
      'Ceremonia Ganga Aarti al atardecer',
      'Talleres de curación con sonido y pranayama',
      'Caminatas por la naturaleza del Himalaya',
      'Comidas vegetarianas sátvicas'
    ],
    itinerary: [
      {
        day: 1,
        title: 'Arrival & Orientation',
        titleEs: 'Llegada y Orientación',
        description: 'Welcome to Rishikesh, check-in at riverside ashram, orientation session, gentle evening yoga, sunset Ganga Aarti',
        descriptionEs: 'Bienvenido a Rishikesh, check-in en ashram junto al río, sesión de orientación, yoga suave por la tarde, Ganga Aarti al atardecer'
      },
      {
        day: 2,
        title: 'Establish Your Practice',
        titleEs: 'Establece tu Práctica',
        description: 'Morning pranayama and meditation, Hatha yoga session, Ayurvedic breakfast, free afternoon, evening restorative yoga',
        descriptionEs: 'Pranayama matutino y meditación, sesión de Hatha yoga, desayuno ayurvédico, tarde libre, yoga restaurativo por la tarde'
      },
      {
        day: 3,
        title: 'Deepening Awareness',
        titleEs: 'Profundizando la Conciencia',
        description: 'Sunrise meditation by the Ganga, Vinyasa flow, Ayurvedic consultation, afternoon sound healing workshop, philosophy class',
        descriptionEs: 'Meditación al amanecer junto al Ganga, flujo Vinyasa, consulta ayurvédica, taller de curación con sonido por la tarde, clase de filosofía'
      },
      {
        day: 4,
        title: 'Nature Connection',
        titleEs: 'Conexión con la Naturaleza',
        description: 'Early morning nature walk in the Himalayas, waterfall meditation, afternoon Ayurvedic treatment, evening Kirtan (devotional singing)',
        descriptionEs: 'Caminata matutina por la naturaleza en el Himalaya, meditación en cascada, tratamiento ayurvédico por la tarde, Kirtan vespertino (canto devocional)'
      },
      {
        day: 5,
        title: 'Inner Journey',
        titleEs: 'Viaje Interior',
        description: 'Yoga Nidra (yogic sleep), intermediate asana practice, chakra balancing session, silent meditation period, group sharing circle',
        descriptionEs: 'Yoga Nidra (sueño yóguico), práctica intermedia de asana, sesión de equilibrio de chakras, período de meditación silenciosa, círculo de compartir grupal'
      },
      {
        day: 6,
        title: 'Integration',
        titleEs: 'Integración',
        description: 'Sunrise yoga, temple visit, Ayurvedic cooking class, final Ayurvedic treatment, closing ceremony and group dinner',
        descriptionEs: 'Yoga al amanecer, visita al templo, clase de cocina ayurvédica, tratamiento ayurvédico final, ceremonia de cierre y cena grupal'
      },
      {
        day: 7,
        title: 'Departure',
        titleEs: 'Salida',
        description: 'Morning meditation, closing circle, check-out and transfer',
        descriptionEs: 'Meditación matutina, círculo de cierre, check-out y traslado'
      }
    ],
    inclusions: [
      'Accommodation in riverside ashram (6 nights)',
      'All satvik vegetarian meals',
      'Daily yoga and meditation sessions',
      'Ayurvedic consultation and 2 treatments',
      'Sound healing workshop',
      'Nature walks with guide',
      'Ayurvedic cooking class',
      'Course materials'
    ],
    inclusionsEs: [
      'Alojamiento en ashram junto al río (6 noches)',
      'Todas las comidas vegetarianas sátvicas',
      'Sesiones diarias de yoga y meditación',
      'Consulta ayurvédica y 2 tratamientos',
      'Taller de curación con sonido',
      'Caminatas por la naturaleza con guía',
      'Clase de cocina ayurvédica',
      'Materiales del curso'
    ],
    exclusions: [
      'International flights',
      'Travel to/from Rishikesh',
      'Travel insurance',
      'Additional Ayurvedic treatments',
      'Personal expenses',
      'Gratuities'
    ],
    exclusionsEs: [
      'Vuelos internacionales',
      'Viaje hacia/desde Rishikesh',
      'Seguro de viaje',
      'Tratamientos ayurvédicos adicionales',
      'Gastos personales',
      'Propinas'
    ],
    pricing: {
      showPrice: false, // CMS toggle: Show/hide numeric price
      basePrice: 950, // Hidden from UI, kept for internal reference
      currency: 'USD',
      perPerson: true,
      groupDiscount: 'Early bird: 15% off (book 60 days in advance)',
      groupDiscountEs: 'Reserva anticipada: 15% de descuento (reserva con 60 días de anticipación)',
      note: 'Private room available for additional cost',
      noteEs: 'Habitación privada disponible por un costo adicional'
    },
    gallery: [
      'https://images.unsplash.com/photo-1758797315487-b3b225dff7d8?crop=entropy&cs=srgb&fm=jpg&q=85',
      'https://images.unsplash.com/photo-1678788166239-b28733f56956?crop=entropy&cs=srgb&fm=jpg&q=85',
      'https://images.unsplash.com/photo-1570804485046-b5b8d795dc5d?crop=entropy&cs=srgb&fm=jpg&q=85',
      'https://images.unsplash.com/photo-1623823501504-50e80f4f15e9?crop=entropy&cs=srgb&fm=jpg&q=85'
    ],
    faqs: [
      {
        question: 'Do I need prior yoga experience?',
        questionEs: '¿Necesito experiencia previa en yoga?',
        answer: 'No, this retreat welcomes all levels. Our teachers adapt practices to suit individual needs.',
        answerEs: 'No, este retiro da la bienvenida a todos los niveles. Nuestros maestros adaptan las prácticas a las necesidades individuales.'
      },
      {
        question: 'What should I bring?',
        questionEs: '¿Qué debo traer?',
        answer: 'Comfortable yoga clothes, yoga mat (can be provided), water bottle, journal, and open mind!',
        answerEs: 'Ropa cómoda de yoga, tapete de yoga (se puede proporcionar), botella de agua, diario y mente abierta!'
      },
      {
        question: 'Is the food vegetarian?',
        questionEs: '¿La comida es vegetariana?',
        answer: 'Yes, we serve satvik vegetarian meals aligned with yogic principles. Special dietary needs can be accommodated.',
        answerEs: 'Sí, servimos comidas vegetarianas sátvicas alineadas con los principios yóguicos. Se pueden acomodar necesidades dietéticas especiales.'
      }
    ],
    metaTitle: 'Rishikesh Yoga & Wellness Retreat - 7 Days | POMTrips',
    metaDescription: 'Transform your life with daily yoga, meditation, Ayurvedic treatments, and spiritual practices by the sacred Ganga River in Rishikesh, India.',
    relatedTours: [1, 3]
  },
  {
    id: 3,
    slug: 'jim-corbett-wildlife-safari',
    name: 'Jim Corbett Wildlife Safari',
    nameEs: 'Safari de Vida Silvestre Jim Corbett',
    metaTitle: 'Jim Corbett Wildlife Experience | Peace of Mind Trips',
    metaDescription: 'Experience wildlife and nature at Jim Corbett National Park with Peace of Mind Trips through safaris, forests, and responsible travel.',
    tagline: 'Where tigers roam free',
    taglineEs: 'Donde los tigres deambulan libres',
    duration: '4 Days',
    durationEs: '4 Días',
    category: 'wildlife',
    heroImage: 'https://images.unsplash.com/photo-1676634694424-2938c2d7da43?crop=entropy&cs=srgb&fm=jpg&q=85',
    heroVideo: null,
    summary: 'Experience the thrill of spotting Bengal tigers in their natural habitat at India\'s oldest national park. This wildlife adventure takes you deep into Corbett\'s diverse ecosystems, home to over 600 species of birds and mammals.',
    summaryEs: 'Experimenta la emoción de avistar tigres de Bengala en su hábitat natural en el parque nacional más antiguo de India. Esta aventura de vida silvestre te lleva profundamente a los diversos ecosistemas de Corbett, hogar de más de 600 especies de aves y mamíferos.',
    highlights: [
      'Multiple jeep safaris in different zones',
      'Expert naturalist guides',
      'Bird watching sessions',
      'Visit to Corbett Museum',
      'Nature walks and forest trails',
      'Riverside bonfire evenings'
    ],
    highlightsEs: [
      'Múltiples safaris en jeep en diferentes zonas',
      'Guías naturalistas expertos',
      'Sesiones de observación de aves',
      'Visita al Museo Corbett',
      'Caminatas por la naturaleza y senderos forestales',
      'Tardes de fogata junto al río'
    ],
    itinerary: [
      {
        day: 1,
        title: 'Arrival at Jim Corbett',
        titleEs: 'Llegada a Jim Corbett',
        description: 'Pick up from Ramnagar, check-in at jungle lodge, orientation about park, evening nature walk, dinner and wildlife documentary',
        descriptionEs: 'Recogida en Ramnagar, check-in en lodge de la jungla, orientación sobre el parque, caminata nocturna por la naturaleza, cena y documental de vida silvestre'
      },
      {
        day: 2,
        title: 'Dhikala Zone Safari',
        titleEs: 'Safari Zona Dhikala',
        description: 'Early morning jeep safari in Dhikala zone (best for tiger sightings), breakfast at lodge, afternoon bird watching session, evening safari in Bijrani zone',
        descriptionEs: 'Safari temprano en la mañana en jeep en la zona Dhikala (mejor para avistar tigres), desayuno en el lodge, sesión de observación de aves por la tarde, safari vespertino en la zona Bijrani'
      },
      {
        day: 3,
        title: 'Explore Corbett',
        titleEs: 'Explora Corbett',
        description: 'Morning safari in Jhirna zone, visit to Corbett Museum and Garjiya Devi Temple, lunch at lodge, evening riverside nature walk, bonfire and wildlife stories',
        descriptionEs: 'Safari matutino en la zona Jhirna, visita al Museo Corbett y Templo Garjiya Devi, almuerzo en el lodge, caminata nocturna por la naturaleza junto al río, fogata e historias de vida silvestre'
      },
      {
        day: 4,
        title: 'Final Safari & Departure',
        titleEs: 'Safari Final y Salida',
        description: 'Last morning safari, breakfast, check-out, drop to Ramnagar station or Delhi (extra cost)',
        descriptionEs: 'Último safari matutino, desayuno, check-out, traslado a la estación Ramnagar o Delhi (costo extra)'
      }
    ],
    inclusions: [
      'Accommodation in jungle lodge (3 nights)',
      'All meals (breakfast, lunch, dinner)',
      '4 jeep safaris with naturalist',
      'Park entry fees',
      'Nature walks with guide',
      'Bird watching sessions',
      'Transfer from/to Ramnagar'
    ],
    inclusionsEs: [
      'Alojamiento en lodge de la jungla (3 noches)',
      'Todas las comidas (desayuno, almuerzo, cena)',
      '4 safaris en jeep con naturalista',
      'Tarifas de entrada al parque',
      'Caminatas por la naturaleza con guía',
      'Sesiones de observación de aves',
      'Traslado desde/hacia Ramnagar'
    ],
    exclusions: [
      'Transport to/from Delhi',
      'Travel insurance',
      'Camera fees',
      'Personal expenses',
      'Alcoholic beverages',
      'Gratuities'
    ],
    exclusionsEs: [
      'Transporte hacia/desde Delhi',
      'Seguro de viaje',
      'Tarifas de cámara',
      'Gastos personales',
      'Bebidas alcohólicas',
      'Propinas'
    ],
    pricing: {
      showPrice: false, // CMS toggle: Show/hide numeric price
      basePrice: 650, // Hidden from UI, kept for internal reference
      currency: 'USD',
      perPerson: true,
      groupDiscount: 'Family packages available',
      groupDiscountEs: 'Paquetes familiares disponibles',
      note: 'Peak season (Nov-Feb) may have higher rates',
      noteEs: 'La temporada alta (nov-feb) puede tener tarifas más altas'
    },
    gallery: [
      'https://images.unsplash.com/photo-1676634694424-2938c2d7da43?crop=entropy&cs=srgb&fm=jpg&q=85',
      'https://images.pexels.com/photos/29666820/pexels-photo-29666820.png?auto=compress&cs=tinysrgb&w=800'
    ],
    faqs: [
      {
        question: 'When is the best time to visit?',
        questionEs: '¿Cuándo es el mejor momento para visitar?',
        answer: 'November to June. Park is closed during monsoon (July-October).',
        answerEs: 'De noviembre a junio. El parque cierra durante el monzón (julio-octubre).'
      },
      {
        question: 'What are chances of seeing a tiger?',
        questionEs: '¿Cuáles son las posibilidades de ver un tigre?',
        answer: 'While not guaranteed, Corbett has good tiger population. Multiple safaris increase chances.',
        answerEs: 'Aunque no está garantizado, Corbett tiene una buena población de tigres. Múltiples safaris aumentan las posibilidades.'
      },
      {
        question: 'Is it safe for children?',
        questionEs: '¿Es seguro para niños?',
        answer: 'Yes, safaris are conducted in enclosed jeeps with experienced guides. Minimum age is usually 5 years.',
        answerEs: 'Sí, los safaris se realizan en jeeps cerrados con guías experimentados. La edad mínima suele ser de 5 años.'
      }
    ],
    metaTitle: 'Jim Corbett Wildlife Safari - 4 Days | POMTrips',
    metaDescription: 'Spot Bengal tigers and exotic wildlife in India\'s oldest national park. Multiple safaris, expert naturalists, and immersive jungle experience.',
    relatedTours: [1, 2]
  },
  {
    id: 4,
    slug: 'golden-triangle',
    name: 'Golden Triangle: Delhi, Agra & Jaipur',
    nameEs: 'Triángulo Dorado: Delhi, Agra y Jaipur',
    metaTitle: 'Golden Triangle Tour (Delhi Agra Jaipur) | Peace of Mind Trips',
    metaDescription: 'Experience India\'s iconic Golden Triangle—Delhi, Agra, and Jaipur—with Peace of Mind Trips through heritage monuments, culture, and local stories.',
    tagline: 'Classic India - History, palaces, and timeless beauty',
    taglineEs: 'India Clásica - Historia, palacios y belleza atemporal',
    duration: '6 Days',
    durationEs: '6 Días',
    category: 'heritage',
    heroImage: 'https://images.unsplash.com/photo-1477587458883-47145ed94245?w=1200&q=85',
    heroVideo: null,
    summary: 'Experience India\'s most iconic Golden Triangle route connecting Delhi, Agra, and Jaipur. This classic journey showcases the best of Mughal and Rajput architecture, from the majestic Taj Mahal to the pink palaces of Jaipur. Witness stunning forts, vibrant markets, and rich cultural heritage across three of India\'s most historically significant cities.',
    summaryEs: 'Experimenta la ruta del Triángulo Dorado más icónica de India que conecta Delhi, Agra y Jaipur. Este viaje clásico muestra lo mejor de la arquitectura mogol y rajput, desde el majestuoso Taj Mahal hasta los palacios rosados de Jaipur.',
    highlights: [
      'Private sunrise viewing at the Taj Mahal',
      'Traditional inlay art workshop in Agra',
      'Jaipur Pink City heritage walk with local guide',
      'Delhi Old City rickshaw ride and spice market',
      'Amber Fort elephant experience',
      'Hawa Mahal and City Palace tours'
    ],
    highlightsEs: [
      'Vista privada del amanecer en el Taj Mahal',
      'Taller de arte de incrustación tradicional en Agra',
      'Paseo patrimonial por Jaipur Ciudad Rosa con guía local',
      'Paseo en rickshaw por Old Delhi y mercado de especias',
      'Experiencia de elefante en el Fuerte Amber',
      'Tours del Hawa Mahal y Palacio de la Ciudad'
    ],
    itinerary: [
      {
        day: 1,
        title: 'Arrival in Delhi',
        titleEs: 'Llegada a Delhi',
        description: 'Airport pickup, hotel check-in, evening orientation and welcome dinner. Optional: Evening walk around India Gate',
        descriptionEs: 'Recogida en el aeropuerto, check-in en el hotel, orientación vespertina y cena de bienvenida'
      },
      {
        day: 2,
        title: 'Delhi Sightseeing',
        titleEs: 'Turismo en Delhi',
        description: 'Full day exploring Old and New Delhi: Red Fort, Jama Masjid, Chandni Chowk rickshaw ride, Raj Ghat, India Gate, Qutub Minar, Humayun\'s Tomb',
        descriptionEs: 'Día completo explorando el viejo y nuevo Delhi: Fuerte Rojo, Jama Masjid, paseo en rickshaw por Chandni Chowk, Raj Ghat, India Gate, Qutub Minar'
      },
      {
        day: 3,
        title: 'Delhi to Agra',
        titleEs: 'Delhi a Agra',
        description: 'Morning drive to Agra (3-4 hours), afternoon visit to Agra Fort and Mehtab Bagh for sunset Taj view, evening inlay art workshop',
        descriptionEs: 'Viaje matutino a Agra, visita vespertina al Fuerte de Agra y Mehtab Bagh para ver el atardecer del Taj'
      },
      {
        day: 4,
        title: 'Taj Mahal & Drive to Jaipur',
        titleEs: 'Taj Mahal y Viaje a Jaipur',
        description: 'Pre-dawn Taj Mahal sunrise visit, return for breakfast, drive to Jaipur via Fatehpur Sikri (abandoned Mughal city), evening arrival in Jaipur',
        descriptionEs: 'Visita al amanecer del Taj Mahal, desayuno, viaje a Jaipur vía Fatehpur Sikri, llegada vespertina'
      },
      {
        day: 5,
        title: 'Jaipur - The Pink City',
        titleEs: 'Jaipur - La Ciudad Rosa',
        description: 'Amber Fort visit with elephant ride option, City Palace and Jantar Mantar observatory, Hawa Mahal photo stop, evening bazaar walk and shopping',
        descriptionEs: 'Visita al Fuerte Amber con opción de paseo en elefante, Palacio de la Ciudad, Jantar Mantar, Hawa Mahal'
      },
      {
        day: 6,
        title: 'Jaipur to Delhi Departure',
        titleEs: 'Jaipur a Delhi Salida',
        description: 'Morning at leisure or optional Albert Hall Museum visit, drive back to Delhi (5 hours), airport drop for evening flights',
        descriptionEs: 'Mañana libre u opción de visitar el Museo Albert Hall, regreso a Delhi, traslado al aeropuerto'
      }
    ],
    inclusions: [
      'Accommodation in heritage/boutique hotels (5 nights)',
      'Daily breakfast and 2 lunches',
      'Private air-conditioned vehicle for all transfers',
      'English/Spanish-speaking guide',
      'All monument entrance fees',
      'Taj Mahal sunrise visit',
      'Inlay art workshop',
      'Rickshaw rides'
    ],
    inclusionsEs: [
      'Alojamiento en hoteles patrimoniales/boutique (5 noches)',
      'Desayuno diario y 2 almuerzos',
      'Vehículo privado con aire acondicionado',
      'Guía de habla inglesa/española',
      'Todas las tarifas de entrada',
      'Visita al amanecer del Taj Mahal',
      'Taller de arte de incrustación',
      'Paseos en rickshaw'
    ],
    exclusions: [
      'International flights',
      'Visa fees',
      'Travel insurance',
      'Dinners (except welcome dinner)',
      'Personal expenses',
      'Tips and gratuities',
      'Camera fees at monuments'
    ],
    exclusionsEs: [
      'Vuelos internacionales',
      'Tarifas de visa',
      'Seguro de viaje',
      'Cenas (excepto cena de bienvenida)',
      'Gastos personales',
      'Propinas',
      'Tarifas de cámara en monumentos'
    ],
    pricing: {
      showPrice: false,
      basePrice: 900,
      currency: 'USD',
      perPerson: true,
      groupDiscount: 'Groups of 4+: 10% discount',
      groupDiscountEs: 'Grupos de 4+: 10% de descuento',
      note: 'Customizable dates and accommodation',
      noteEs: 'Fechas y alojamiento personalizables'
    },
    gallery: [
      {
        url: 'https://customer-assets.emergentagent.com/job_wanderlust-elite/artifacts/s0cxirbu_20190218_103651_edited.jpg',
        alt: 'Golden Triangle Tour — Taj Mahal with visitors — Peace of Mind Trips and Travels',
        caption: 'Taj Mahal, Agra'
      },
      {
        url: 'https://customer-assets.emergentagent.com/job_wanderlust-elite/artifacts/cayss4us_20190218_104313_edited.jpg',
        alt: 'Golden Triangle Tour — Taj Mahal archway view — Peace of Mind Trips and Travels',
        caption: 'Taj Mahal through archway'
      },
      {
        url: 'https://customer-assets.emergentagent.com/job_wanderlust-elite/artifacts/eqmko7mc_20190218_065935_edited.jpg',
        alt: 'Golden Triangle Tour — Taj Mahal sunrise from boat — Peace of Mind Trips and Travels',
        caption: 'Taj Mahal at sunrise'
      },
      {
        url: 'https://images.unsplash.com/photo-1587474260584-136574528ed5?w=1200&q=85',
        alt: 'Golden Triangle Tour — India Gate Delhi — Peace of Mind Trips and Travels',
        caption: 'India Gate, Delhi'
      },
      {
        url: 'https://images.unsplash.com/photo-1477587458883-47145ed94245?w=1200&q=85',
        alt: 'Golden Triangle Tour — Hawa Mahal Jaipur — Peace of Mind Trips and Travels',
        caption: 'Hawa Mahal, Jaipur'
      },
      {
        url: 'https://images.unsplash.com/photo-1599661046289-e31897846e41?w=1200&q=85',
        alt: 'Golden Triangle Tour — Amber Fort Jaipur — Peace of Mind Trips and Travels',
        caption: 'Amber Fort, Jaipur'
      }
    ],
    faqs: [
      {
        question: 'Is this tour suitable for first-time visitors to India?',
        questionEs: '¿Este tour es adecuado para visitantes primerizos a India?',
        answer: 'Absolutely! The Golden Triangle is perfect for first-timers as it covers India\'s most iconic destinations with comfortable accommodations and experienced guides.',
        answerEs: '¡Absolutamente! El Triángulo Dorado es perfecto para principiantes ya que cubre los destinos más icónicos de India.'
      },
      {
        question: 'Can the itinerary be customized?',
        questionEs: '¿Se puede personalizar el itinerario?',
        answer: 'Yes! We offer fully customizable itineraries. You can extend your stay, add or remove destinations, or adjust the pace.',
        answerEs: '¡Sí! Ofrecemos itinerarios completamente personalizables. Puedes extender tu estadía o ajustar el ritmo.'
      },
      {
        question: 'What is the best time for this tour?',
        questionEs: '¿Cuál es el mejor momento para este tour?',
        answer: 'October to March offers the best weather. Avoid April-June (extreme heat) and July-September (monsoon).',
        answerEs: 'De octubre a marzo ofrece el mejor clima. Evita abril-junio (calor extremo) y julio-septiembre (monzón).'
      }
    ],
    metaTitle: 'Golden Triangle Tour — Delhi • Agra • Jaipur | POMTrips',
    metaDescription: 'Explore India\'s Golden Triangle: Delhi, Agra, and Jaipur. Visit Taj Mahal, Amber Fort, and Red Fort on this classic 6-day heritage journey with small groups and Spanish-friendly guides.',
    relatedTours: [1, 2]
  }
];